import { StyledTick } from "./styles/StyledTick";

const Tick = () => (
  <StyledTick>
    <path d="M1 5.23287L4.52154 9L12 1" stroke="#AD1FEA" strokeWidth="2" />
  </StyledTick>
);

export default Tick;
